import { Empty } from '../../components';
import { t } from 'i18next';
import s from './index.module.less';

export const emptyContent = {
  emptyText: <Empty className={s.fontBlack} description={t('NoData')} />,
};

export default emptyContent;
